<span [class]="classes()">
  <ng-content></ng-content>
</span>
